module.exports = __webpack_public_path__ + "static/img/main.ddfd36d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/8/main.png
// module id = N5Wa
// module chunks = 1